import * as React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import router from "./routes/index.jsx";
import { CustomThemeProvider } from "themes/CustomThemeProvider";
import { SupabaseAuthProvider } from "contexts/SupabaseAuthContext";
import { AxiosProvider } from "services/axios-supabase";
import { Provider } from "react-redux";
import store from "./store/store";
import { CssBaseline } from "@mui/material";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SupabaseAuthProvider>
        <AxiosProvider>
          <CustomThemeProvider>
            <CssBaseline />
            <RouterProvider router={router} />
          </CustomThemeProvider>
        </AxiosProvider>
      </SupabaseAuthProvider>
    </Provider>
  </React.StrictMode>
);
